import React from 'react';
import head from 'lodash/head';
import intersectionBy from 'lodash/intersectionBy';
import { Alert, AlertType } from '@yme/atoms/alert';
import { Col, Row } from '@yme/atoms/grid';
import { NOT_FOUND_URL } from '@yme/common/constants';
import { FilterCompareCard } from '@yme/molecules/cards';
import { NoResultComponent } from '@yme/molecules/no-results-component';
import { useQueryParams } from '@yme/organisms/test-ride-grid/useQueryParams';
import { useTranslation } from '@yme/services/i18n';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { noop } from '@yme/utils/common';
import { getTestRideUrl } from '@yme/utils/product';
import { TestRideContentSkeleton } from './TestRideContentSkeleton';
import { TEST_RIDE_ERROR_ALERT_TEST_ID } from './constants';
export function TestRideContent({ languageRootPath, isError, isLoaded, demoUnits, testRideFormLinks, isRightToLeft, onClick, isInEditor, currentPerPageValue, }) {
    const { t } = useTranslation();
    const { getQueryParams } = useQueryParams({});
    const { dealerId, isIframe } = getQueryParams();
    const TestRideCards = demoUnits.map((product) => {
        const { name, image, driverLicense, inRiverIds, sku, isYAMTTransmission, id } = product;
        const url = head(intersectionBy(testRideFormLinks, inRiverIds, 'key'));
        const urlWithQuery = url
            ? getTestRideUrl({
                url: url.value,
                sku,
                dealerId,
                isIframe,
            })
            : '';
        const onLinkClick = (id, url) => {
            return () => onClick?.(id, url);
        };
        return (React.createElement(Col, { lg: 4, md: 4, key: id },
            React.createElement(FilterCompareCard, { image: image, title: name, driverLicense: driverLicense, isRightToLeft: isRightToLeft, url: urlWithQuery || `${languageRootPath}/${NOT_FOUND_URL}`, onClick: onLinkClick(sku, urlWithQuery), handleAddComparisonProduct: noop, handleRemoveComparisonProduct: noop, isChecked: false, isDisabled: false, isCheckBoxNeeded: false, isYAMTIconShowed: isYAMTTransmission })));
    });
    if (!isLoaded && !isInEditor) {
        return React.createElement(TestRideContentSkeleton, { currentPerPageValue: currentPerPageValue });
    }
    return (React.createElement(Row, { mt: "32px" }, isError ? (React.createElement(Col, null,
        React.createElement(Alert, { type: AlertType.ERROR, message: t('common_somethingWentWrong_message'), dataTestId: TEST_RIDE_ERROR_ALERT_TEST_ID }))) : demoUnits.length ? (TestRideCards) : (isLoaded && (React.createElement(FlexWrapper, { padding: "24px", gap: "12px", flexDirection: "column", alignItems: "center", isFullWidth: true },
        React.createElement(NoResultComponent, { noResultTitle: t('productsGrid_noProductsFound_label'), noResultDescription: t('productsGrid_changeTestRideFilters_hint') }))))));
}
